/* eslint-disable object-curly-newline */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */

/**
 * HTMLからタグ内の文字列を返却する
 * @param str 文字列
 * @returns string
 */
export const getTextFromHTML = (str: string) => {
    return str.replace(/<[^>]+>/g, "");
};
